import React, { useState } from 'react';

const HeroFive = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        service: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
    };

    return (
        <section
            className="hero-wrapper hero-5 bg-cover"
            style={{ backgroundImage: `url(/img/elevating-homes1.svg)` }}
        >
            <div className="container">
                <div className="row align-items-center hero-5-inner">
                    {/* Left: Hero Content */}
                    <div className="col-12 col-lg-6 col-md-7">
                        <div className="hero-contents hero-5-content">
                            <h1 className="wow fadeInLeft" data-wow-duration="1.3s">
                                AC Maintenance And AMC Services in UAE – Same Day AC Service Near You
                            </h1>
                            <p className="hero-5-subtext wow fadeInLeft" data-wow-duration="1.3s" data-wow-delay=".3s">
                                We provide same day AC service near you for apartments, villas, offices, and commercial buildings.
                            </p>
                            <ul className="hero-5-checklist wow fadeInLeft" data-wow-duration="1.3s" data-wow-delay=".5s">
                                <li><i className="fas fa-check-circle"></i> 24/7 Emergency AC Service</li>
                                <li><i className="fas fa-check-circle"></i> Free Inspection</li>
                                <li><i className="fas fa-check-circle"></i> Certified HVAC Technicians</li>
                                <li><i className="fas fa-check-circle"></i> Transparent Pricing</li>
                                <li><i className="fas fa-check-circle"></i> Service Across UAE</li>
                            </ul>
                            <a
                                href="https://wa.me/971502033924"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="theme-btn wow fadeInLeft"
                                data-wow-duration="1.2s"
                                data-wow-delay=".8s"
                            >
                                Get Quote
                            </a>
                        </div>
                    </div>

                    {/* Right: Consultation Form */}
                    <div className="col-12 col-lg-5 offset-lg-1 col-md-5">
                        <div className="hero-consultation-form wow fadeInRight" data-wow-duration="1.2s" data-wow-delay=".4s">
                            <h3 className="consultation-title">Get Free Consultation</h3>
                            <form onSubmit={handleSubmit}>
                                <div className="consultation-form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="consultation-form-group">
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Phone Number"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="consultation-form-group">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email ID"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="consultation-form-group">
                                    <select
                                        name="service"
                                        value={formData.service}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="" disabled>Choose Service</option>

                                        <option value="general-ac-service">General AC Service</option>
                                        <option value="ac-repairs">AC Repairs</option>
                                        <option value="ac-duct-cleaning">AC Duct Cleaning</option>
                                        <option value="ac-deep-cleaning">AC Deep Cleaning</option>
                                        <option value="ac-coil-cleaning">AC Coil Cleaning</option>
                                        <option value="amc">Annual Maintenance Contract (AMC)</option>
                                        <option value="split-ac-installation">Split AC Installation</option>
                                        <option value="centralized-hvac">Centralized HVAC Systems</option>
                                        <option value="ducted-split-systems">Ducted Split Systems</option>
                                        <option value="package-units">Package Units</option>
                                        <option value="vrf-vrv-systems">VRF / VRV Systems</option>
                                        <option value="chilled-water-fcu">Chilled Water FCU Installation</option>
                                        <option value="fresh-air-ventilation">Fresh Air & Ventilation Systems</option>
                                        <option value="ac-gas-topup">AC Gas Top-Up / Refrigerant Refill</option>
                                        <option value="ac-drain-leakage">AC Drain Line & Water Leakage Service</option>
                                        <option value="ac-electrical-thermostat">AC Electrical & Thermostat Check</option>
                                    </select>
                                </div>
                                <button type="submit" className="theme-btn consultation-submit-btn">
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroFive;